import { TEXT_ROW } from '../formName';

import { PureComponent } from 'react';
import { Field, Form, reduxForm } from 'redux-form/immutable';

import { Button } from 'components/Button/Button';
import { Map as ImmutableMap } from 'immutable';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { handleSubmitFail } from 'utils/formValidation';
import OverviewPropTypes from '../../OverviewPropTypes';
import TextRowField from './TextRowField';

const validate = (values) => {
  const errors = {};
  const variables = values.get('variables');
  if (!variables) {
    errors.variables = 'requiredOptions';
  }
  return errors;
};

@reduxForm({
  form: TEXT_ROW,
  enableReinitialize: true,
  onSubmitFail: handleSubmitFail('btn-save'),
  validate,
})
export default class TextRowForm extends PureComponent {
  static propTypes = {
    editWidget: OverviewPropTypes.editWidget,
    handleSubmit: PropTypes.func,
    msg: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    textRow: OverviewPropTypes.textRow,
  };

  render() {
    const { editWidget, handleSubmit, onClose, submitting, textRow, msg } =
      this.props;
    const textRowVariables = get(msg, ['textRowVariables'], {});
    return (
      <div>
        <Form onSubmit={handleSubmit}>
          <fieldset className='p-3' disabled={submitting}>
            <div className='form-group'>
              <Field
                autoFocus
                block
                component={TextRowField}
                id={`${TEXT_ROW}-variable`}
                initialValues={new ImmutableMap({ variables: '' })}
                msg={msg}
                name='variables'
                options={textRowVariables}
                textRow={textRow}
                type='select'
              />
            </div>
          </fieldset>
          <div className='dashboard__add-widget-footer'>
            <Button
              className='mr-2'
              icon='fa-check'
              id='btn-save'
              type='submit'
              variant='primary'
              data-testid='widget-options-btn-save'
            >
              {editWidget
                ? get(msg, ['dialog', 'btnSelect'])
                : get(msg, ['dialog', 'btnAdd'])}
            </Button>
            <Button variant='secondary' onClick={onClose} type='button'>
              {get(msg, ['dialog', 'btnBack'])}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
